import VersionContent from '.';
const VersionIosPage = () => {
  return <VersionContent />;
};

export default VersionIosPage;
